import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { DMA_REPORT_ID } from './dmaReportId';

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.DMA_CODE.field,
    FIELDS.SPENT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.CLICKS.field,
    FIELDS.VCTR.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.VCPM.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CVR.field,
    FIELDS.CPA.field,
].map(field => generateColumnId(DMA_REPORT_ID, field));

const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.SPENT.field,
        FIELDS.VISIBLE_IMPRESSIONS.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.CLICKS.field,
        FIELDS.VCTR.field,
        FIELDS.AVERAGE_CPC.field,
        FIELDS.VCPM.field,
        FIELDS.CONVERSIONS_VALUE.field,
        FIELDS.CONVERSIONS.field,
        FIELDS.CVR.field,
        FIELDS.CPA.field,
        FIELDS.ROAS.field,
    ].map(field => generateColumnId(DMA_REPORT_ID, field)),
};

export { customColumns, defaultColumns };
